<template>
  <div class="wrap">
    <es-loader/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueRouter from 'vue-router'
import EsLoader from '@/components/EsLoader.vue';
import axios from 'axios';

const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
  components: {
    EsLoader,
  },
  async mounted() {
    // Check session exists or not
    let hasUserSession = false;
    try {
      const responseSession = await axios.get('/session');
      const { data: userSession } = responseSession;
      hasUserSession = true;
    } catch {
      // if fails, no user-session exists
      hasUserSession = false;
    }
    // console.log(`Landing.mounted(): hasUserSession=${hasUserSession}`);

    // Check if SSO is enabled or not
    const url = '/login/sso/properties';
    const response = await axios.get(url);

    const ssoProperties = response.data;
    const isSsoEnabled = ssoProperties.SSO_THIRD_PARTY;
    // console.log(`Landing.mounted(): Check SSO enabled - isSsoEnabled=${isSsoEnabled}`);
    if (!hasUserSession && isSsoEnabled === 'true') {
      // isSsoEnabled is 'true' indicates SSO is enabled. then redirect to SSO Login-page
      // console.log('Landing.mounted(): user-session not exists and SSO is enabled - getting SSO-Redirect-URL...');

      // Get client's redirect-url
      const ssoRedirectUrl = ssoProperties.SSO_REDIRECT_URL;

      if (ssoRedirectUrl && ssoRedirectUrl.trim() !== '') {
        // ssoRedirectUrl has valid value, redirect to ssoRedirectUrl
        // console.log(`Landing.mounted(): user-session not exists and SSO is enabled - redirect to SSO Login-page: ${ssoRedirectUrl}`);
        const ssoRedirectUrlFull = `${ssoRedirectUrl}?r=${this.$route.query.r}`;
        // console.log(`Landing.mounted(): user-session not exists and SSO is enabled - ssoRedirectUrlFull=${ssoRedirectUrlFull}`);
        window.location.href = ssoRedirectUrlFull;
      } else {
        console.log('*** Error - check ssoProperties.SSO_REDIRECT_URL property');
      }
    } else {
      console.log('SSO is not enabled');

      const { query } = this.$route;
      const login = {
        path: '/login',
        query,
      };

      // try to load session and properties async
      try {
        await Promise.all([
          this.initSession(),
          this.initProperties(),
          this.initFields(),
        ]);
        // console.log('Landing.mounted(): user-session exists or SSO is NOT enabled - query.r=' + query.r);

        // navigate to where we were trying to go
        this.$router.push(query.r || '/')
          .catch((e) => {
            if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
              Promise.reject(e);
            }
          });
      } catch {
        // at least one promise failed, go to login route
        // console.log('Landing.mounted(): user-session exists or SSO is NOT enabled - in catch()');
        const isLocalAuthenticationEnabled = ssoProperties.LOCAL_AUTHENTICATION;
        // console.log('Landing.mounted(): isLocalAuthenticationEnabled', isLocalAuthenticationEnabled);
        if (isLocalAuthenticationEnabled === 'true') {
          this.$router.push(login);
        } else {
          this.$router.push({ name: 'notAuthorized' });
        }
      }
    }
  },
  methods: {
    ...mapActions({
      initProperties: 'propertiesModule/init',
      initSession: 'initSession',
      initFields: 'fieldLabelsModule/init',
    }),
  },
};
</script>

<style lang="sass" scoped>
  .wrap
    height: 100vh
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
</style>
